// services/connections/ancillaryService.ts
import {BaseConnectionService} from './baseConnectionService';
import {AncillaryConnection} from "../../types/ancillary";


class AncillaryConnectionService extends BaseConnectionService<AncillaryConnection> {
    constructor() {
        super('ancillaries');
    }
}

export const ancillaryConnectionService = new AncillaryConnectionService();